// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmPayoutDialog-Dialog_cls1__jTEMF","cls2":"ConfirmPayoutDialog-Dialog_cls2__gvAwR ConfirmPayoutDialog-Dialog_cls1__jTEMF"};